module.exports = __webpack_public_path__ + "static/media/loading.2a74d4eb.svg";